const i18next = require('i18next');

const initClientI18n = (options) => {
  const isTest = process.env.NODE_ENV === 'test';
  const isLocal = process.env.DEPLOY_ENV === 'local';

  i18next.init({
    debug: isLocal && !isTest,
    initImmediate: isTest,
    fallbackLng: 'en',
    ns: ['translation', 'enums'],
    supportedLngs: ['en', 'es', 'fr-CA'],
    interpolation: { escapeValue: false },
    ...options,
  });
};

module.exports = { initClientI18n };
